import { createSelector } from '@reduxjs/toolkit';
import { selectApp } from './selectApp';

/** Select saved template */
export const selectSavedTemplate = createSelector([selectApp], (state) => {
  return state.savedTemplate;
});
